<template>
  <div>
    <b-card-text>
      対象に攻撃します。
      <b-alert show variant="secondary">
        (自己STR×威力係数+威力固定値)×(クリティカルLv+1) - 対象VIT
      </b-alert>
    </b-card-text>
    <b-form-group id="STRRatio" label="威力係数">
      <b-form-input v-model="innerValue.arguments.STRRatio" 
        type="number" :min="0" :max="99" :step="0.1" number />
    </b-form-group>
    <b-form-group id="ADamage" label="威力固定値">
      <b-form-input v-model="innerValue.arguments.ADamage" 
        type="number" :min="0" :max="99" :step="1" number />
    </b-form-group>
    <b-form-group id="accurate" label="減衰乱数">
      <b-form-input v-model="innerValue.arguments.accurate" 
        type="number" :min="0" :max="1" :step="0.01" number />
    </b-form-group>
    <b-button variant="danger" size="sm"
      @click="$emit('removeCode')">
      <b-icon icon="x" />削除
    </b-button>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    value: Object
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  created () {
    if(!this.innerValue.arguments.player){
      _.assign(this.innerValue.arguments, {
        player: { '@arg':'player' },
        target: { '@arg':'target' },
        dice: { '@arg':'dice' },

        ADamage: 1,
        accurate: 1.0,
        STRRatio: 1.0,
      })
    }
  },
  watch: {
    'innerValue.arguments' () {
      this.$emit('input', this.innerValue)
    },
    value (v) {
      this.innerValue = v
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
